import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Form, Input, Button, message } from 'antd';
import { checkPhone } from '@/utils'
import { fetchLoginPhone } from '@/store/modules/user'
import { getToken } from '@/utils/token'
import './Login.scss'

export default function Login(info) {
  const dispatch = useDispatch()
  const [loginType, setLoginType] = useState(0)
  const [formData, setFormData] = useState({
    phone: '',
    password: '',
  })
  

  const getWXLogin = () => {
    //	实现副作用操作逻辑
    new window.WxLogin({
      self_redirect: false,
      id: 'qrcode',
      appid: 'wxcfaabd88a3ae0c38',
      scope: 'snsapi_login',
      redirect_uri: encodeURIComponent(window.location.protocol + '//www.wufangtong.com/#/?a=1'),
      state: '4321432dsadgrewt43fdas',
      style: '',
      href: '0',
      stylelite: 1
    })
  }

  const changeLoginType = (type) => {
    if(type === loginType){
      return
    }
    if(type == 0) {
      getWXLogin()
    }
    setLoginType(type)
  }
  const changeForm = e => {
    if('phone' in e) {
      setFormData({
        ...formData,
        phone: e.phone
      })
    } else if('password' in e) {
      setFormData({
        ...formData,
        password: e.password
      })
    }
  }
  const submitForm = async values => {
    setFormData({
      ...formData,
      phone: values.phone,
      password: values.password,
    })
    if(!checkPhone(values.phone)) {
      message.error('手机号格式不正确')
      return
    }
    if(values.password.length > 12 || values.password.length < 6) {
      message.error('密码格式不正确')
      return
    }
    await dispatch(fetchLoginPhone(formData))
    const token = getToken()
    if(token) {
      setTimeout(() => {
        window.location.replace('/')
      }, 2000)
    }
  }
  
  useEffect(() => {
    getWXLogin()
  }, [])

  let { onLoginPopup } = info

  return (
    <div className="popup flex-center">
      <div className="popup-close" onClick={() => onLoginPopup()}></div>
      <div className="popup-page" style={{width: '282px', height: '308px'}}>
        <div className="flex-center margin-bottom-32 line-height-24 font-size14">
          <div className={loginType == 0 ? 'margin-left-24 margin-right-24 login-type' : 'margin-left-24 margin-right-24'} onClick={() => changeLoginType(0)}>微信登录</div>
          <div className={loginType == 1 ? 'margin-left-24 margin-right-24 login-type' : 'margin-left-24 margin-right-24'} onClick={() => changeLoginType(1)}>账号登录</div>
        </div>
        <div className={loginType == 0 ? '' : 'none'}>
          <div className="title">请使用微信扫码登录</div>
          <div id="qrcode" className="wx-qrcode" />
        </div>
        <Form className={loginType != 0 ? '' : 'none'} initialValues={formData} onValuesChange={changeForm} onFinish={submitForm}>
          <Form.Item name="phone">
            <Input placeholder="手机号" allowClear className="margin-top-32 bg-fafafa padding-top-10 padding-bottom-10" />
          </Form.Item>
          <Form.Item name="password">
            <Input.Password placeholder="密码" className="bg-fafafa padding-top-10 padding-bottom-10" />
          </Form.Item>
          <Form.Item>
            <Button block size="large" htmlType="submit" className="submitBtn bg-green white padding-top-10 padding-bottom-10 font-size16 line-height-24">
              提交
            </Button>
          </Form.Item>
          <div className="margin-top-24 font-size16 line-height-24 align-center color-999999">首次登录请使用“微信登录”绑定手机号</div>
        </Form>
      </div>
    </div>
    
    // <div className="popup flex-center" onClick={() => onLoginPopup()}>
    //   <div className="popup-page">
    //     <div className="title">
    //       <div>武房通PC端封测中</div>
    //       <div>敬请期待</div>
    //       <div>扫码加微信</div>
    //     </div>
    //     <div className="qrcode">
    //       <img src="/images/qrcode.png" alt="" className='img' />
    //     </div>
    //   </div>
    // </div>
  )
}
